import { render } from "./Routeprofile.vue?vue&type=template&id=4ef04cac"
import script from "./Routeprofile.vue?vue&type=script&lang=js"
export * from "./Routeprofile.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__